import type { ReactNode } from "react";

export function StateMessage({
  kind,
  children,
}: {
  kind: "loading" | "error" | "empty" | "info";
  children: ReactNode;
}) {
  return <div className={`state state-${kind}`}>{children}</div>;
}
